import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.99256 17.5625C7.84256 17.5625 7.72256 17.5325 7.63256 17.495C7.33256 17.3825 6.82256 17.015 6.82256 15.8525V11.015H5.06756C4.06256 11.015 3.70256 10.5425 3.57506 10.265C3.44756 9.97997 3.33506 9.40247 3.99506 8.64497L9.67256 2.19497C10.4376 1.32497 11.0601 1.38497 11.3601 1.49747C11.6601 1.60997 12.1701 1.97747 12.1701 3.13997V7.97747H13.9251C14.9301 7.97747 15.2901 8.44997 15.4176 8.72747C15.5451 9.01247 15.6576 9.58997 14.9976 10.3475L9.32006 16.7975C8.78756 17.405 8.32256 17.5625 7.99256 17.5625ZM10.9476 2.55497C10.9251 2.58497 10.7676 2.65997 10.5201 2.94497L4.84256 9.39497C4.63256 9.63497 4.60256 9.78497 4.60256 9.81497C4.61756 9.82247 4.75256 9.89747 5.06756 9.89747H7.38506C7.69256 9.89747 7.94756 10.1525 7.94756 10.46V15.86C7.94756 16.235 8.01506 16.4 8.04506 16.445C8.06756 16.415 8.22506 16.34 8.47256 16.055L14.1501 9.60497C14.3601 9.36497 14.3901 9.21497 14.3901 9.18497C14.3751 9.17747 14.2401 9.10247 13.9251 9.10247H11.6076C11.3001 9.10247 11.0451 8.84747 11.0451 8.53997V3.13997C11.0526 2.76497 10.9776 2.60747 10.9476 2.55497Z",
  fill: "#2353F5"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }